export default __webpack_public_path__ + "static/media/celulares.63861a6a.png";